module.exports = __webpack_public_path__ + "img/mp-schedule-item-bg_active.46912d1b.jpg";